module.exports = __webpack_public_path__ + "static/media/mountain_biking_1024.1c49db8f.webp";